import React from "react";
import Reveal from "@/components/Reveal";
import { Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Anna Kowalska",
    role: "Klientka prywatna",
    text:
      "Profesjonalizm na każdym etapie. Pan Mrozek doradził rozwiązanie, którego sami byśmy nie wymyślili, a finalny nagrobek przerósł nasze oczekiwania.",
  },
  {
    name: "Marek Wiśniewski",
    role: "Inwestor",
    text:
      "Zamówiliśmy schody granitowe i parapety do całego domu. Pomiar precyzyjny, montaż błyskawiczny, jakość pierwsza klasa.",
  },
  {
    name: "Joanna Lis",
    role: "Restauratorka",
    text:
      "Blaty do naszego lokalu wyglądają zjawiskowo — i bronią się też w codziennej eksploatacji. Polecam każdemu, kto szuka rzemiosła z najwyższej półki.",
  },
  {
    name: "Tomasz Nowak",
    role: "Klient prywatny",
    text:
      "Renowacja starego nagrobka rodziny wyszła rewelacyjnie. Czuje się, że to ludzie, którym naprawdę zależy.",
  },
  {
    name: "Krystyna Adamczyk",
    role: "Klientka prywatna",
    text:
      "Polecam całym sercem. Konkurencyjna cena, terminowość, no i ten kunszt — szczegóły dopracowane perfekcyjnie.",
  },
];

export default function Testimonials() {
  const track = [...REVIEWS, ...REVIEWS];

  return (
    <section id="opinie" data-testid="testimonials-section" className="relative py-24 md:py-36 bg-[#050505] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 mb-14">
        <Reveal>
          <p className="overline mb-6">Opinie klientów</p>
          <h2 className="section-title text-white text-4xl md:text-6xl leading-[1.04] max-w-3xl">
            Słowa, które
            <br />
            <span className="italic text-neutral-300">zobowiązują nas codziennie</span>.
          </h2>
        </Reveal>
      </div>

      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 z-10 bg-gradient-to-r from-[#050505] to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 z-10 bg-gradient-to-l from-[#050505] to-transparent pointer-events-none" />

        <div className="flex marquee-track w-max gap-6 px-6">
          {track.map((r, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="hairline bg-[#0a0a0a] w-[320px] md:w-[420px] p-7 md:p-9 flex flex-col gap-5"
            >
              <Quote size={26} strokeWidth={1} className="text-[var(--accent)]" />
              <p className="font-serif-display text-white text-xl md:text-2xl leading-snug">
                {`„${r.text}"`}
              </p>
              <div className="mt-auto pt-6 border-t border-white/10">
                <p className="text-white text-sm">{r.name}</p>
                <p className="text-[11px] uppercase tracking-[0.25em] text-neutral-500 mt-1">
                  {r.role}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
